import { useFormContext, useWatch } from 'react-hook-form';

import { FoodFormValues } from '../interfaces/FoodFormValues';
import { getRoundedNumber } from '../../../../shared/utils/mathUtils';
import { calculateMealCalories } from '../../../../shared/utils/mealUtils';

export const useFoodCalories = () => {
  const { control } = useFormContext<FoodFormValues>();

  const [proteins, carbs, fats] = useWatch({
    control,
    name: ['nutrients.proteins', 'nutrients.carbs', 'nutrients.fats'],
  });
  // an emptied input holds '' until it is valid again
  return getRoundedNumber(
    calculateMealCalories({
      proteins: proteins || 0,
      carbs: carbs || 0,
      fats: fats || 0,
    }),
    3,
  );
};
